import { INameId } from '@modeso/types__aumico-lib-core-be';
import { INameIdWithSortedItems } from '../types/name-id-with-sorted-items.type';

export interface IAddSubtotalFormDialogResult {
    subtotalName: string;
    positionBeforeSubtotal: INameId;
    positionBeforeSubtotalIndex: number;
    scopedGroup: INameIdWithSortedItems;
}
